import React, { useState } from 'react';

interface ContactFormData {
  name: string;
  email: string;
  message: string;
}

const ContactForm: React.FC = () => {
  const [formData, setFormData] = useState<ContactFormData>({
    name: '',
    email: '',
    message: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = () => {
    setIsSubmitting(true);
    // FormSubmit se encarga del envío automáticamente
  };

  return (
    <div className="contact-form-section">
      <form 
        id="contact-form" 
        method="POST" 
        action="https://formsubmit.co/gema.ruiz.gordillo@gmail.com"
        className="contact-form" 
        onSubmit={handleSubmit}
      >
        {/* FormSubmit configuration */}
        <input type="hidden" name="_captcha" value="false" />
        <input type="hidden" name="_next" value={`${window.location.origin}/portfolio?sent=true`} />
        <input type="hidden" name="_subject" value="Nueva consulta desde el portfolio web" />
        
        <div className="form-group">
          <label htmlFor="name">Nombre *</label>
          <input 
            type="text" 
            id="name" 
            name="name" 
            value={formData.name}
            onChange={handleChange}
            required 
            placeholder="Tu nombre completo"
            disabled={isSubmitting}
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="email">Email *</label>
          <input 
            type="email" 
            id="email" 
            name="email" 
            value={formData.email}
            onChange={handleChange}
            required 
            placeholder="tu@email.com"
            disabled={isSubmitting}
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="message">Mensaje *</label>
          <textarea 
            id="message" 
            name="message" 
            rows={6} 
            value={formData.message}
            onChange={handleChange}
            required 
            placeholder="Cuéntame sobre tu proyecto, ideas, fechas disponibles, etc..."
            disabled={isSubmitting}
          ></textarea>
        </div>
        
        <div className="form-actions">
          <button 
            type="submit" 
            className="button primary large"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <i className="icon solid fa-spinner fa-spin"></i>
                Enviando...
              </>
            ) : (
              <>
                <i className="icon solid fa-paper-plane"></i>
                Enviar Mensaje
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ContactForm;
